import axios from 'axios';

// The environment variable REACT_APP_API_URL should contain the base URL,
// and we'll append /api/v1 here. Handle cases where /api/v1 might already be included.
const baseUrl = process.env.REACT_APP_API_URL || 'https://care360-backend.onrender.com';
const API_BASE_URL = baseUrl.endsWith('/api/v1') ? baseUrl : baseUrl + '/api/v1';

console.log('[api.js] Environment REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
console.log('[api.js] Processed base URL:', baseUrl);
console.log('[api.js] Final API baseURL:', API_BASE_URL);

const instance = axios.create({
  baseURL: API_BASE_URL,
});

// Helper function to check if request is for portal
const isPortalRequest = (config) => {
  return config.url && (
    config.url.includes('/portal/') ||
    config.url.includes('/intake/') ||
    config.url.startsWith('/portal') ||
    config.url.startsWith('/intake')
  );
};

// Add request interceptor to include authentication token
instance.interceptors.request.use(
  config => {
    // Do not attach main auth token to portal requests, as they have their own auth
    if (isPortalRequest(config)) {
      return config;
    }

    // Get the token from localStorage (stored as 'authToken' by AuthContext)
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle 401 errors
instance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // Handle 401 errors (unauthorized)
    if (error.response && error.response.status === 401) {
      // Don't handle 401s for portal requests, login requests, or requests with bypass flag
      const isPortalReq = isPortalRequest(error.config);
      const isLoginReq = error.config.url && error.config.url.includes('/login');
      const bypassInterceptor = error.config.bypassGlobalInterceptor;

      if (!isPortalReq && !isLoginReq && !bypassInterceptor) {
        console.warn('401 Unauthorized - clearing auth token');
        localStorage.removeItem('authToken');
        // Optionally redirect to login page
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
